import statusTypes from "../../status-types";
import sourceTypes from "../../source-types";
import propertyTypes from "../../property-types";
import propertyCategories from "../../property-categories";
import propertySubCategories from "../../property-sub-categories";    
import transactionTypes from "../../transaction-types";
import leaseTypes from "../../lease-types";
import markets from "../../markets";
import buyerMarkets from "../../buyer-markets";
import singleTenantSubcategories from "../../single-tenant-subcategories";
import multiTenantSubcategories from "../../multi-tenant-subcategories";
import singleMultiTenantIndustrialSubcategories from "../../single-multi-tenant-industrial-subcategories";
import singleTenantOffice from "../../single-tenant-office-subcategories.js";
import multiTenantOffice from "../../multi-tenant-office-subcategories.js";
import unitedStates from "united-states";
import profiles from "../../profiles";
import buyerStatus from "../../buyer-status";
import sellerStatus from "../../seller-status";
import pipelines from "../../pipelines";
import checkboxTypes from '../../checkbox-types';
import statusTypesFinancing from "../../status-types-financing";
import loanTypes from "../../loan-types";
import filters from "../../filters";
import teamMembers from "../../hsc-team-members";
import loanQuotesAmortization from "../../loanquotes-amortization";
import { getSuperUsers } from "../../super-users";
import estimatedPrice from "../../estimated-price";
import referralType from "../../referral-type"
import confirmType from "../../confirm-type";
import roles from "../../roles";
import contactTypes from "../../contactTypes.js";
import investorStatus from "../../investor-status.js";
import investorMarkets from "../../investor-markets .js";
import titleCompanies from "../../title-companies.js";
import type_code from "../../userType.js"
import vendorTypes from "../../vendor-type.js"
import user_type from "../../extendedPropertiesUser_Type";
import status_code from "../../userStatusCode.js";
//const superUsers = getSuperUsers();
export const getOptionsType = (optionsType,client={},vendorData=[]) => {
    switch (optionsType) {
        case 'status':
            return statusTypes;
        case 'source':
            return sourceTypes;
        case 'type':
            return propertyTypes;
        case 'category':
            return propertyCategories;
        case 'subcategory':
            return propertySubCategories;
        case 'transaction':
            return transactionTypes;
        case 'lease':
            return leaseTypes;
        case 'market':
            return markets;
        case 'buyer-market':
            return buyerMarkets;
        case 'investor-market':
            return investorMarkets;
        case 'subcategorySTNL':
            return singleTenantSubcategories;
        case 'subcategoryMT':
            return multiTenantSubcategories;
        case 'subcategoryIndustrialSTNLMT':
            return singleMultiTenantIndustrialSubcategories;
        case 'singleTenantOffice':
            return singleTenantOffice;
        case 'multiTenantOffice':
            return multiTenantOffice;
        case 'states':
            return unitedStates.filter(el => !el.isTerritory);
        case 'superUsers':
            return getSuperUsers(client);
        case 'profiles':
            return profiles;
        case 'buyerStatus':
            return buyerStatus;
        case 'investorStatus':
            return investorStatus;
        case 'pipeline':
            return pipelines;
        case 'checkbox':
            return checkboxTypes;
        case 'status-financing':
            return statusTypesFinancing;
        case 'loan':
            return loanTypes;
        case 'filters':
            return filters;
        case 'sellerStatus':
            return sellerStatus;
        case 'team-members':
            return teamMembers;
        case 'loanquotes-amortization':
            return loanQuotesAmortization;
        case 'estimatedPrice':
            return estimatedPrice;
        case 'referralType':
            return referralType;
        case 'confirmType':
            return confirmType;
        case 'roles':
            return roles;
        case 'title-companies':
            return titleCompanies.concat(vendorData);    
        case 'contactType':
            return contactTypes;
        case 'vendorType':
            return vendorTypes;
        case 'user_type':
            return user_type    
        case 'type_code' : 
        return type_code ;
        case 'status_code':
        return status_code;

    }
    return null;
};